import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import cn from "classnames";
import styles from "./CompanyCreate.module.sass";
import { Link } from "react-router-dom";
import Icon from "../../components/Icon";

// Screens
import PartnerInformations from "./PartnerInformations";
import AddressInformations from "./AddressInformations";
import AdminInformations from "./AdminInformations";
import ContactInformations from "./ContactInformations";

// Services
import { createPartner } from "../../services/partner.service";
import { showSuccess, showError } from "../../services/toast.service";

const PartnerCreate = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [partnerData, setPartnerData] = useState({});

  const handlePartnerChange = (e) => {
    const { name, value } = e.target;
    setPartnerData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSwitchChange = (name, value) => {
    setPartnerData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (name, value) => {
    // Extraire uniquement la valeur du dropdown si c'est un objet avec une propriété value
    let finalValue = value && typeof value === 'object' && value.value !== undefined ? value.value : value;
    setPartnerData((prev) => ({ ...prev, [name]: finalValue }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      await createPartner(partnerData);
      showSuccess("Partenaire créé avec succès!");
      navigate("/partners");
    } catch (err) {
      const errorMessage =
        "Impossible de créer le partenaire: " +
        (err.message || "Veuillez vérifier les informations saisies.");
      showError(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.container}>
        <Link className={cn("button-white", styles.button)} to="/partners">
          <Icon name="arrow-left" />
          Retour
        </Link>

        <div className={styles.background}>
          <img src="/images/content/bg-shop.jpg" alt="Background" />
        </div>

        <div className={styles.formContainer}>
          {error && <div className={styles.error}>{error}</div>}
          <form onSubmit={handleSubmit}>
            <PartnerInformations
              partner={partnerData}
              onPartnerChange={handlePartnerChange}
              onDropdownChange={handleDropdownChange}
              onSwitchChange={handleSwitchChange}
            />
            <AddressInformations
              partner={partnerData}
              onPartnerChange={handlePartnerChange}
            />
            <AdminInformations
              partner={partnerData}
              onPartnerChange={handlePartnerChange}
            />
            <ContactInformations
              partner={partnerData}
              onPartnerChange={handlePartnerChange}
              onDropdownChange={handleDropdownChange}
              loading={loading}
            />
      
          </form>
        </div>
      </div>
    </>
  );
};

export default PartnerCreate;
